import * as React from "react";
import * as ReactDOM from "react-dom";

interface IProperties
{
    children?: any;
}

export class ContextMenu extends React.Component<IProperties>
{
    render()
    {
        return (
            <div className="contextmenu">
                {this.props.children}
            </div>
        );
    }
}